import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField
} from '@material-ui/core';

import { addVendor, updateVendor } from 'redux/actions';

const VendorDetails = (props) => {

  const [values, setValues] = useState({
    name: props.vendorInfo.name,
    phone: props.vendorInfo.phone,
    trn: props.vendorInfo.trn
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if(props.update) {
      const updatedVendor = {
        id: props.vendorInfo.id,
        updates: {
          name: values.name,
          phone: values.phone
        }
      };
      props.updateVendor(updatedVendor);
    }
    else {
      const newVendor = {
        displayId: props.vendorInfo.displayId,
        name: values.name,
        phone: values.phone,
        trn: values.trn
      };
      props.addVendor(newVendor, false, props.activeUserId);
    }
    
    props.cancelAddUpdate();
  };

  return (
    <form
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <Card>
        <CardHeader
          subheader="The information can be edited later"
          title="Vendor"
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please specify the name"
                label="Name"
                name="name"
                onChange={handleChange}
                required
                value={values.name}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Please specify the Phone Number"
                label="Phone Number"
                name="phone"
                onChange={handleChange}
                required
                value={values.phone}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                disabled={props.update}
                fullWidth
                helperText="Please specify the TRN"
                label="TRN"
                name="trn"
                onChange={handleChange}
                required
                value={values.trn}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2
          }}
        >
          <Button
            color="primary"
            variant="contained"
            type="submit"
          >
            Save details
          </Button>
          <Button sx={{ mx: 1 }} onClick={props.cancelAddUpdate.bind(this)}>
            Cancel
          </Button>
        </Box>
      </Card>
    </form>
  )
};

export default connect (null, {addVendor, updateVendor}) (VendorDetails);